<template>
  <div
    v-studio-click-outside="() => (isOpen = false)"
    class="tw-relative tw-w-full tw-text-xs"
    data-testid="chat-settings"
  >
    <button
      class="tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2 tw-text-left hover:tw-border-gray-400 focus:tw-outline-none"
      @click="isOpen = !isOpen"
    >
      <span>
        {{ selectedOption ? selectedOption.label : 'Select an option' }}
      </span>
      <svg
        class="tw-h-4 tw-w-4 tw-transform tw-text-gray-500 tw-transition-transform tw-duration-200"
        :class="{ 'tw-rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div
      v-if="isOpen"
      class="tw-absolute tw-z-10 tw-mt-1 tw-max-h-60 tw-w-full tw-overflow-auto tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-shadow-lg"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="tw-cursor-pointer tw-px-4 tw-py-2 tw-transition hover:tw-bg-gray-100"
        @click="selectOption(option)"
      >
        <div class="tw-text-xs tw-font-medium tw-text-gray-900">
          {{ option.label }}
        </div>
        <div class="tw-text-2xs tw-text-gray-500">
          {{ option.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

type Option = {
  value: any;
  label: string;
  description: string;
};

const props = defineProps<{
  options: Option[];
  selectedOption: Option | null;
}>();

const emit = defineEmits<{
  (e: 'onSelect', option: Option): void;
}>();

const isOpen = ref(false);

function selectOption(option) {
  isOpen.value = false;
  emit('onSelect', option);
}
</script>
